import { Action, createReducer, on } from '@ngrx/store';
import { IUser } from '../../interfaces/user.interface';
import * as userActions from '../actions/user.actions';

export const userFeatureKey = 'user';

export interface State {
    currentUser: IUser;
    isAdmin: boolean;
}

export const initialState: State = {
    currentUser: null,
    isAdmin: false
};

const userReducer = createReducer(
    initialState,
    on(userActions.getUserSuccess, userActions.createInitialUserSuccess, (state, { user, isAdmin }) => ({
        ...state,
        currentUser: user,
        isAdmin
    })),
    on(
        userActions.toggleFavouriteFromUserSuccess,
        userActions.addRecentlySeenToUserSuccess,
        userActions.updateUserSettingsSuccess,
        (state, { user }) => ({
            ...state,
            currentUser: user
        })
    ),
    on(userActions.setIsAdminSuccess, (state, { isAdmin }) => ({
        ...state,
        isAdmin
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return userReducer(state, action);
}
